import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../../components/index';
import { doMultipartFormPostExigencias } from '../../../utils/requests';
import UploadDragDrop from '../../../components/ComponentesBasicos/UploadDragDrop';

class ModalUploadDocumento extends Component {
  constructor() {
    super();
    this.state = {
      documents: [],
      tipoDocumento: null,
      tiposDisponiveis: [],
      nomeDependente: null,
      exibirNomeDependente: false,
    };
  }

  componentDidMount() {
    this.montaListaDocumentosDisponiveis();
  }

  montaListaDocumentosDisponiveis = () => {
    const lista = [];
    if (this.props.requerimento &&
      this.props.requerimento.exigencias) {
      this.props.requerimento.exigencias.forEach((exigencia) => {
        if (exigencia.tipoDocumento && (!exigencia.atributo)) {
          let acaoFormatada = exigencia.acao;
          if (exigencia.tipoDocumento === 13) {
            if (exigencia.comentario) {
              acaoFormatada = `${exigencia.acao} - ${exigencia.comentario}`;
            }
          }
          lista.push({
            value: exigencia.codigoDependente ?
              `${exigencia.tipoDocumento}${exigencia.codigoDependente}` : exigencia.tipoDocumento,
            label: acaoFormatada,
            dependente: exigencia.codigoDependente,
          });
        }
      });
    }
    this.setState({
      tiposDisponiveis: lista,
    });
  }

  checkIfFileCanBeSent = () => (this.state.documents.length > 0 && this.state.tipoDocumento)

  modalDocumentUploadContent = () => (
    <React.Fragment>
      {this.state.exibirNomeDependente ?
        <div className="row">
          <Grid cols="8 8 12 12">
            <Input
              label="Dependente"
              value={this.state.nomeDependente}
              disabled
            />
          </Grid>
        </div>
      : '' }
      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Tipo de documento"
            number
            placeholder="Selecione o tipo de documento"
            onChange={e => this.handleChange(e, 'tipoDocumento')}
            value={this.state.tipoDocumento}
            itemList={this.state.tiposDisponiveis}
            required
            custom
          />
        </Grid>
      </div>
      <UploadDragDrop
        files={this.state.documents}
        onChange={documents => this.setState({ documents })}
        multiple={false}
        accept="application/pdf,.pdf"
        minHeight={70}
        titulo="Arraste o arquivo PDF aqui"
        subtitulo="ou clique para selecionar"
      />
    </React.Fragment>
  )

  modalDocumentUploadFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Anexar documento"
          onClick={this.uploadFile}
          title="Anexar"
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => { // 15365899
    let paramExibirNomeDependente = false;
    const listaDependentes = this.props.requerimento.dependentes;
    const listaExigencias = this.props.requerimento.exigencias;
    let paramNomeDependente = '';
    let dependente = '';
    let valor = '';
    let codigoDependente = '';

    if (listaExigencias && listaExigencias.length > 0) {
      for (let i = 0, tam = listaExigencias.length; i < tam; i += 1) {
        const exigencia = listaExigencias[i];
        if (exigencia.tipoDocumento && exigencia.codigoDependente) {
          valor = `${exigencia.tipoDocumento}${exigencia.codigoDependente}`;
          if (Number(valor) === changeObj.value) {
            dependente = valor.match(exigencia.codigoDependente);
            break;
          }
        }
      }
      if (dependente !== '') {
        codigoDependente = Number(dependente[0]);
        const indexDep =
        listaDependentes.findIndex(depDisp => (depDisp.codigo === codigoDependente));
        paramNomeDependente = listaDependentes[indexDep].nome;
        if (paramNomeDependente !== '') {
          paramExibirNomeDependente = true;
        }
        this.setState({
          nomeDependente: paramNomeDependente,
          exibirNomeDependente: paramExibirNomeDependente,
        });
      }
    }

    if (changeObj.value === '') {
      paramNomeDependente = '';
      paramExibirNomeDependente = false;
      this.setState({
        nomeDependente: paramNomeDependente,
        exibirNomeDependente: paramExibirNomeDependente,
      });
    }

    this.setState({
      [name]: changeObj.value,
    });
  }

  handleChangeFile = (file) => {
    this.setState({
      document: file,
    });
  }

  uploadFile = () => {
    const { documents } = this.state;
    if (!documents || documents.length === 0) {
      return;
    }
    const documentoAtual = documents[0];
    if (documentoAtual) {
      const listaExigencias = this.props.requerimento.exigencias;
      const listaDependentes = this.props.requerimento.dependentes;
      const { tipoDocumento } = { ...this.state };
      let tipoDoc = '';
      let valor = '';
      const url = 'documentos';
      let body = '';
      if (listaDependentes && listaDependentes.length > 0) {
        for (let i = 0, tam = listaExigencias.length; i < tam; i += 1) {
          const exigencia = listaExigencias[i];
          if (exigencia.tipoDocumento && exigencia.codigoDependente) {
            valor = `${exigencia.tipoDocumento}${exigencia.codigoDependente}`;
            if ((Number(valor)) === tipoDocumento) {
              tipoDoc = valor.match(exigencia.tipoDocumento);
              tipoDoc = Number(tipoDoc[0]);
              break;
            }
          } else if (exigencia.tipoDocumento && !exigencia.codigoDependente) {
            tipoDoc = exigencia.tipoDocumento;
            break;
          }
        }
        body = {
          protocolo: this.props.requerimento.protocolo,
          documento: documentoAtual,
          tipoDocumento: tipoDoc,
        };
      } else {
        body = {
          protocolo: this.props.requerimento.protocolo,
          documento: documentoAtual,
          tipoDocumento: this.state.tipoDocumento,
        };
      }
      doMultipartFormPostExigencias(
        url,
        body,
        this.handleDocumentSent,
        this.props.handleFailDocumentSent,
      );
    }
    this.setState({
      documents: [],
    });
  }

  handleDocumentSent = (response) => {
    const tipoDocumentoCarregado = this.state.tipoDocumento;
    this.setState(
      {
        document: null,
        tipoDocumento: null,
        tiposDisponiveis: [],
      },
      () => this
        .props
        .handleDocumentSent(response.headers.location, tipoDocumentoCarregado),
    );
  }

  handleClose = () => {
    this.setState({ document: null }, this.props.handleModal('showDocumentUploadModal'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalDocumentUploadFooter()}
        conteudomodal={this.modalDocumentUploadContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Incluir documento ao requerimento"
      />
    );
  }
}

ModalUploadDocumento.propTypes = {
  exigencia: PropTypes.func,
  protocolo: PropTypes.string,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleDocumentSent: PropTypes.func,
}.isRequired;

export default ModalUploadDocumento;



// WEBPACK FOOTER //
// ./src/pages/consultas/Exigencia/ModalUploadDocumento.jsx